import { RfidValidCell, RfidInvalidCell } from './rfid_cells';
import RfidCellValidator from './rfid_cell_validator';
import RfidCellRenderer from './rfid_cell_renderer';
import { isEmpty } from '@fretadao/f-js-utils';

export default class RfidRowBuilder{
  constructor(columns, { cellValidator, renderer, fileSizeLimit } = this.defaultOpts()){
    this.fileSizeLimit = fileSizeLimit;
    this.columns = columns;
    this.cellValidator = cellValidator;
    this.renderer = renderer;
  }

  build(row, parsingErrors){
    let rowCells = Object.entries(row).map(([header, value], index) => {
      return this.#buildCells(header, value, parsingErrors);
    });

    return rowCells;
  }

  #buildCells(header, value, parsingErrors){
    let cell;
    let validity = this.cellValidator.validate(header, value);
    if(validity && isEmpty(parsingErrors)){
      cell = new RfidValidCell(value, false, this.renderer.onValid);
    }else{
      cell = new RfidInvalidCell(value, true, this.renderer.onInvalid);
    }
    return cell;
  }

  defaultOpts(){
    return {
      cellValidator: new RfidCellValidator(),
      renderer: new RfidCellRenderer(),
      fileSizeLimit: 2 * (1024*1024) // 2 megabytes in bytes
    }
  }
}
